import { useEffect, useMemo } from "react"

import { useLocation } from "react-router-dom"

import { useAppSelector } from "app/hooks"
import { selectUserLoggedIn } from "store/auth/authSlice"

import { AppRoutes } from "../constants/appRoutes"

interface RouteTitle {
  routes: AppRoutes[]
  title: string
}

const ROUTE_TITLES: RouteTitle[] = [
  {
    routes: [AppRoutes.DUMMY],
    title: "Dummy - Whimstay",
  },
  {
    routes: [AppRoutes.RESET_PASSWORD],
    title: "Reset password - Whimstay",
  },
  {
    routes: [AppRoutes.CREATE_PASSWORD],
    title: "Create password - Whimstay",
  },
  {
    routes: [AppRoutes.HOME],
    title: "Listings - Whimstay",
  },
  {
    routes: [AppRoutes.SIGN_UP_RBO],
    title: "Sign up - Whimstay",
  },
  {
    routes: [AppRoutes.VERIFY_EMAIL],
    title: "Verify email - Whimstay",
  },
  {
    routes: [AppRoutes.VERIFY_PROFILE],
    title: "Verify profile - Whimstay",
  },
  {
    routes: [AppRoutes.LISTING_MANAGEMENT],
    title: "Listings management - Whimstay",
  },
  {
    routes: [
      AppRoutes.LISTING_DETAILS_LOCATION,
      AppRoutes.LISTING_DETAILS_PRICING,
      AppRoutes.LISTING_DETAILS_AVAILABILITY,
      AppRoutes.LISTING_DETAILS_PDP,
      AppRoutes.LISTING_DETAILS_CANCELLATION_POLICY,
    ],
    title: "Listing details - Whimstay",
  },
  {
    routes: [AppRoutes.REVIEW_PUBLISH_LISTING],
    title: "Review & publish listing - Whimstay",
  },
  {
    routes: [AppRoutes.MESSAGES],
    title: "Messages - Whimstay",
  },
  {
    routes: [AppRoutes.REVIEWS],
    title: "Reviews - Whimstay",
  },
  {
    routes: [AppRoutes.MANAGE_QUICK_REPLIES],
    title: "Manage quick replies - Whimstay",
  },
  {
    routes: [AppRoutes.SCHEDULED_MESSAGES],
    title: "Scheduled messages - Whimstay",
  },
  {
    routes: [AppRoutes.PROFILE_DETAILS],
    title: "Profile details - Whimstay",
  },
  {
    routes: [AppRoutes.PAYOUT_SETTINGS],
    title: "Payout method - Whimstay",
  },
  {
    routes: [AppRoutes.EARNING_PROGRESS],
    title: "Earnings - Whimstay",
  },
  {
    routes: [AppRoutes.RESERVATIONS],
    title: "Reservations - Whimstay",
  },
  {
    routes: [AppRoutes.PAYOUT],
    title: "Payouts - Whimstay",
  },
  {
    routes: [AppRoutes.PAID_OUT_EXPECTED_REPORT],
    title: "Paid out & expected report - Whimstay",
  },
]

const matchRoute = (path: string, route: string): boolean => {
  const routeRegex = new RegExp(`^${route.replace(/:\w+/g, "[^/]+")}$`)
  return routeRegex.test(path)
}

const PageTitleManager = () => {
  const location = useLocation()
  const isLoggedIn = useAppSelector(selectUserLoggedIn)

  const getPageTitle = useMemo(
    () =>
      (pathname: string): string => {
        const matchedRoute = ROUTE_TITLES.find(({ routes }) =>
          routes.some((route) => matchRoute(pathname, route)),
        )
        return matchedRoute?.title || "Whimstay"
      },
    [],
  )

  useEffect(() => {
    if (!isLoggedIn) {
      document.title = "Sign up & Login - Whimstay"
    } else {
      document.title = getPageTitle(location.pathname)
    }
  }, [location, getPageTitle, isLoggedIn])

  return null
}

export default PageTitleManager
